import React from 'react';
import * as PropTypes from 'prop-types';
import Modal from 'antd-mobile/lib/modal';
import 'antd-mobile/lib/modal/style/css';

Tips.propTypes = {
  visible: PropTypes.bool,
  content: PropTypes.string,
  onPress: PropTypes.func,
  htmlContent: PropTypes.string,
  modalClass: PropTypes.string,
  contentClass: PropTypes.string,
  title: PropTypes.string,
  footer: PropTypes.arrayOf(PropTypes.shape({}))
};

export default function Tips(props) {
  const {
    visible, title, content, onPress, htmlContent, modalClass, contentClass
  } = props;
  let { footer } = props;
  const defaultFooter = [
    {
      text: '知道了',
      onPress: () => {
        onPress();
      }
    }
  ];
  if (footer) {
    footer = footer.map((item) => {
      const { text, onPress: itemOnPress } = item;
      return {
        text,
        onPress: () => {
          if (itemOnPress && itemOnPress.call) {
            itemOnPress();
          }
          onPress();
        }
      };
    });
  }
  return (
    <Modal
      title={title}
      className={`tips-pop ${modalClass}`}
      visible={visible}
      transparent
      maskClosable={false}
      footer={footer || defaultFooter}
    >
      {!htmlContent ? (
        <div className={`tips-pop-content ${contentClass}`}>{content}</div>
      ) : (
        <div
          className={`tips-pop-content ${contentClass}`}
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      )}
    </Modal>
  );
}
